import * as R from 'ramda';
import React, { Fragment, useCallback } from 'react';
// components
import { AddDocument2 } from '../../../../components/activities';
import FilePreview from '../../../../components/document-preview/file-preview';
// helpers/constants
import * as G from '../../../../helpers';
import * as GC from '../../../../constants';
// ui
import { Box, Flex, MainActionButton } from '../../../../ui';
//////////////////////////////////////////////////

export const prepareAndSetDocuments = ({
  doc,
  files,
  aiUpload,
  documents,
  setDocuments,
  defaultDocumentType,
}) => {
  if (R.and(G.isNilOrEmpty(files), G.isNilOrEmpty(doc))) {
    return setDocuments(null);
  }

  if (G.isTrue(aiUpload)) {
    return setDocuments(R.prepend(doc, documents));
  }

  const filesWithProps = files.map((file) => ({
    file,
    guid: G.generateGuid(),
    preview: G.createObjectURL(file),
    documentType: defaultDocumentType,
  }));

  const newDocs = R.concat(R.or(documents, []), filesWithProps);

  return setDocuments(newDocs);
};

const ExpenseAiUpload = (props) => {
  const {
    values,
    setValues,
    documents,
    openLoader,
    aiUploadDoc,
    closeLoader,
    setDocuments,
    setAiUploadDoc,
    aiRecognizeRequest,
    aiUploadDefaultDocumentType,
  } = props;

  const aiUploadGuid = G.getGuidFromObject(aiUploadDoc);

  const filePreview = R.path(['preview'], aiUploadDoc);

  const updateDocument = useCallback((file) => {
    const preview = G.createObjectURL(file);

    const doc = {
      ...aiUploadDoc,
      file,
      preview,
    };

    const guid = G.getGuidFromObject(aiUploadDoc);

    setAiUploadDoc(doc);

    const index = R.findIndex(R.propEq(guid, GC.FIELD_GUID), documents);

    if (R.gte(index, 0)) {
      const documentsToUpdate = R.clone(documents);

      documentsToUpdate[index] = doc;

      setDocuments(documentsToUpdate);
    } else {
      setDocuments(R.prepend(doc, documents));
    }
  }, [
    documents,
    aiUploadDoc,
  ]);

  return (
    <Fragment>
      {
        G.isNilOrEmpty(filePreview) &&
        <Flex justifyContent='center' flexDirection='column'>
          <AddDocument2
            m='0px 15px'
            onDropHandler={async (files) => {
              const file = R.head(files || []);

              openLoader();

              const compressedFile = await G.compressFileIfImageTooLarge(file);

              const callback = (expense) => {
                let newValues = G.mergeWithoutNullUndefinedOrEmptyString(values, expense);

                const date = G.getPropFromObject(GC.FIELD_DATE, newValues);

                if (G.isValidDate(date)) {
                  newValues = R.assoc(
                    GC.FIELD_DATE,
                    G.convertInstanceToDefaultDateTimeFormat(date),
                    newValues,
                  );
                }

                setValues(newValues);
              };

              aiRecognizeRequest(compressedFile, callback);

              const doc = {
                file: compressedFile,
                guid: G.generateGuid(),
                preview: G.createObjectURL(compressedFile),
                documentType: aiUploadDefaultDocumentType,
              };

              setAiUploadDoc(doc);

              prepareAndSetDocuments({
                doc,
                documents,
                aiUpload: true,
                setDocuments,
                aiUploadDefaultDocumentType,
              });

              closeLoader();
            }}
          />
        </Flex>
      }
      {
        filePreview &&
        <Flex
          pl={15}
          fontSize={14}
          justifyContent='space-between'
        >
          <MainActionButton
            type='button'
            onClick={() => {
              setAiUploadDoc(null);

              const newDocs = R.reject(R.propEq(aiUploadGuid, GC.FIELD_GUID), documents);

              setDocuments(newDocs);
            }}
          >
            {G.getWindowLocale('actions:remove-file', 'Remove File')}
          </MainActionButton>
        </Flex>
      }
      { filePreview &&
        <Box p={15} height='calc(100% - 100px)'>
          <FilePreview
            doc={aiUploadDoc}
            updateImage={updateDocument}
            isEditEnabled={G.isNotNilAndNotEmpty(aiUploadDoc)}
          />
        </Box>
      }
    </Fragment>
  );
};

export default ExpenseAiUpload;
